import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import StudentFilesChildren from "StudentPortfolio/routes/PortfolioDetailsV2/routes/ProfileSection/components/StudentFiles/routes/StudentFilesChildren";
export default store => ({
  path: ":studentId(/:activeTab)",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-gradebook" */ "./components"),
        import(
          /* webpackChunkName: "admin-gradebook" */ "StudentProgressSummary/modules/StudentProgressSummaryModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const progressSummaryReducer = importedModule1.default;
        injectReducer(store, {
          key: "studentProgressSummary",
          reducer: progressSummaryReducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [StudentFilesChildren(store)],
});
